(function () {
    const RTAPI_RECONNECT_INTERVAL_SECONDS = 15;
    const COMPLETED_ORDERS_TRIM_INTERVAL_SECONDS = 5;

    class LiveOrdersComponent {
        constructor(
            $scope,
            $uibModal,
            orderUpOrderService,
            PermissionService,
            $state,
            orderUpLookup,
            notify
        ) {
            this._orderUpOrderService = orderUpOrderService;
            this._modalService = $uibModal;
            this._orderUpLookup = orderUpLookup;
            this._notifier = notify;

            this.firstLoad = true;
            this.userContext = PermissionService.getUserContext();
            this.storeName = this.userContext.StoreName;
            this.isOnline = false; // assume offline initially
            this.channelIsEnabled = false; // assume channel disabled initially
            this.orderCompleteNotificationsEnabled = false; // assume notifications disabled initially
            this.isOpen = false;
            this.nextOpeningTime = null;
            this.timeFormat = "hh:mm";
            this.newOrders = [];
            this.acceptedOrders = [];
            this.capturedOrders = [];
            this.completedOrders = [];
            this.selectedOrder = null;
            this.maxDelayTimeInMinutes = 0;
            this.$state = $state;
            this.$scope = $scope;
            this.navigateAwayRegister = null;
            this.delayTimeInMinutes = 0;
            this.audioContext = null;
            this.notification = null;
            this.notificationAudioIsPlaying = false;
            this.isAcceptingOrder = false;
            this.isRemovingOrder = false;
            this.isCapturingOrder = false;
            this.enableAudioModalRef = null;
            this.disconnectedModalRef = null;
            this.connectingRtapiModalRef = null;
            this.channelNotEnabledModalRef = null;
            this.toggleChannelStatusModalRef = null;
            this.showStatusChangedModalRef = null;
            this.acceptWithDelayModalRef = null;
            this.declineModalRef = null;
            this.completeModalRef = null;
            this.completedOrdersMonitor = null;
            this.destroyed = false;

            this.backToListCallback = this.resetSelectedOrder.bind(this);
            this.navigateAwayRegister = this.$scope.$on(
                "$locationChangeStart",
                this.onNavigateAway.bind(this)
            );
            this.init();
        }

        get canAcceptOrders() {
            return this.channelIsEnabled && this.isOnline;
        }

        get onlineStatus() {
            return this.isOnline
                ? "Online"
                : "Offline";
        }

        onNavigateAway(event, toState, fromState) {
            if (!this.newOrders.length || !this.acceptedOrders.length) {
                return;
            }

            event.preventDefault();

            if (this.navigateAwayRegister) {
                this.navigateAwayRegister();
                this.navigateAwayRegister = null;
            }
            this._modalService.open({
                animation: true,
                templateUrl: "components/store/order-up/order-up-outstanding-orders-modal.c625e4ec.html",
                controller: "OrderUpOutstandingOrdersModalController",
                size: "sm",
                backdrop: "static",
                windowClass: "centered-modal",
                resolve: {
                    toState: () => {
                        return toState;
                    },
                    cancelled: () => {
                        return () => {
                            this.navigateAwayRegister = this.$scope.$on(
                                "$locationChangeStart",
                                this.onNavigateAway.bind(this)
                            );
                        };
                    }
                }
            });
        }

        $onInit() {
            $("body").addClass("body-orderup");
            $(".order-up-layout").click(this.minimizeSideBar.bind());
        }

        disableHeartbeatAndDisconnectSocket() {
            this.disableHeartbeat();
            this._orderUpOrderService.disconnectRTAPI();
        }

        $onDestroy() {
            this.destroyed = true;
            this.cleanUp();
            if (!this.navigateAwayRegister) {
                return;
            }
            this.navigateAwayRegister();
            this.navigateAwayRegister = null;
        }

        cleanUp() {
            this.disableHeartbeatAndDisconnectSocket();
            this.closeAllModals();
            this.clearTimeoutsAndIntervals();
            $("body").removeClass("body-orderup");
        }

        clearTimeoutsAndIntervals() {
            if (this._delayedRTAPISetupTimeout) {
                window.clearTimeout(this._delayedRTAPISetupTimeout);
            }
            if (this.completedOrdersMonitor) {
                window.clearInterval(this.completedOrdersMonitor);
            }
        }

        closeAllModals() {
            this.enableAudioModalRef?.close();
            this.channelNotEnabledModalRef?.close();
            this.disconnectedModalRef?.close();
            this.connectingRtapiModalRef?.close();
            this.completeModalRef?.close();
            this.toggleChannelStatusModalRef?.close();
            this.showStatusChangedModalRef?.close();
            this.acceptWithDelayModalRef?.close();
            this.declineModalRef?.close();
        }

        minimizeSideBar() {
            $("body").removeClass("mini-navbar");
            SmoothlyMenu();
        }

        setupNotification() {
            this.notification = new Howl({
                src: ["audio/orderup-notification-2.3f6a912a.mp3"],
                loop: true,
                volume: 1
            });
        }

        unlockAudioContext() {
            if (!this.notification) {
                this.setupNotification();
            }
            try {
                this.notification.mute(true);
                this.notification.play();
                this.notification.stop();
                this.notification.mute(false);
            } catch (e) {
                console.error("Could not enable audio notification", e);
                this._notifier.warn("Could not enable audio notification, order notifications may not work.");
            }
        }

        showEnableAudioModal() {
            this.enableAudioModalRef = this._modalService.open({
                animation: true,
                templateUrl: "components/store/order-up/order-up-enable-audio-modal.219c254c.html",
                controller: "OrderUpEnableAudioModalController",
                size: "sm",
                backdrop: "static",
                windowClass: "centered-modal",
                resolve: {
                    callback: () => {
                        return async () => {
                            this.unlockAudioContext();
                            await this.setup();
                        };
                    }
                }
            });
        }

        showConnectingRtapiModal() {
            if (this.connectingRtapiModalRef) {
                return;
            }
            this.connectingRtapiModalRef = this._modalService.open({
                animation: true,
                templateUrl: "components/store/order-up/order-up-connecting-rtapi-modal.610b58ac.html",
                controller: "OrderUpConnectingRtapiModalController",
                size: "sm",
                backdrop: "static",
                windowClass: "centered-modal",
                resolve: {
                    callback: () => {
                        return () => {
                            this.reloadPage();
                        };
                    }
                }
            });
            this.connectingRtapiModalRef?.result.finally(
                () => { this.connectingRtapiModalRef = null; }
            );
        }

        showDisconnectedModal() {
            if (this.disconnectedModalRef || this.destroyed) {
                return;
            }
            this.disconnectedModalRef = this._modalService.open({
                animation: true,
                templateUrl: "components/store/order-up/order-up-disconnected-modal.22705a1a.html",
                controller: "OrderUpDisconnectedModalController",
                size: "sm",
                backdrop: "static",
                windowClass: "centered-modal",
                resolve: {
                    callback: () => {
                        return () => {
                            this.reloadPage();
                        };
                    }
                }
            });
            this.disconnectedModalRef?.result.finally(
                () => { this.disconnectedModalRef = null; }
            );
        }

        showChannelNotEnabledModal() {
            if (this.channelNotEnabledModalRef) {
                return;
            }
            this.channelNotEnabledModalRef = this._modalService.open({
                animation: true,
                templateUrl: "components/store/order-up/order-up-channel-disabled-modal.d3d6d913.html",
                controller: "OrderUpNotEnabledModalController",
                size: "sm",
                backdrop: "static",
                windowClass: "centered-modal",
                resolve: {
                    callback: () => {
                        return () => {
                            this.reloadPage();
                        };
                    }
                }
            });
            this.channelNotEnabledModalRef?.result.finally(
                () => { this.channelNotEnabledModalRef = null; }
            );
        }

        reloadPage() {
            window.location.reload();
        }

        async setStoreStateFrom(result) {
            this.disconnectedModalRef?.close();
            if (!result) {
                return;
            }
            this.isOnline = !!result.IsOnline;
            this.channelIsEnabled = !!result.ChannelIsEnabled;
            this.orderCompleteNotificationsEnabled = !!result.OrderCompleteNotificationsEnabled;
            this.nextOpeningTime = result.NextOpeningTime;
            this.isOpen = result.IsOpen;
            this.maxDelayTimeInMinutes = result.MaxDelayTimeInMinutes;
            const shouldEnableRealTimeMessaging = this.isOnline
                && this.channelIsEnabled
                && !this._orderUpOrderService.isRTAPIConnected()
                && !this._orderUpOrderService.isRTAPIConnecting();
            if (shouldEnableRealTimeMessaging) {
                await this.setupRealTimeMessaging();
            }
            if (!this.channelIsEnabled) {
                this.connectingRtapiModalRef?.close();
                this.showChannelNotEnabledModal();
            }
        }

        enableOfflineMode() {
            this.newOrders = [];
            this.acceptedOrders = [];
            this.capturedOrders = [];
            this.completedOrders = [];
            this.resetSelectedOrder();
            this.disableHeartbeatAndDisconnectSocket();
            this.stopAudioNotification();
        }

        async handleChannelStatusToggle(result) {
            await this.setStoreStateFrom(result);
            if (this.isOnline) {
                await this.setup();
            } else {
                this.enableOfflineMode();
            }
        }

        toggleChannelStatus() {
            this.toggleChannelStatusModalRef = this._modalService.open({
                animation: true,
                templateUrl: "components/store/order-up/order-up-toggle-status-modal.ea7da794.html",
                controller: "OrderUpToggleStatusModalController",
                size: "sm",
                backdrop: "static",
                windowClass: "centered-modal",
                resolve: {
                    channelIsOnline: () => {
                        return this.canAcceptOrders;
                    },
                    callback: () => {
                        return async (result) => {
                            await this.handleChannelStatusToggle(result);
                        };
                    }
                }
            });
        }

        init() {
            this.showEnableAudioModal();
        }

        enableHeartbeat() {
            this._orderUpOrderService.enableHeartbeat(
                parseInt(this.$state.params.storeId),
                this.setStoreStateFrom.bind(this),
                this.showDisconnectedModal.bind(this)
            );
        }

        disableHeartbeat() {
            this._orderUpOrderService.disableHeartbeat();
        }

        async setupRealTimeMessaging() {
            try {
                await this._orderUpOrderService.connectRTAPI();
                this.completeRealTimeMessagingSetup();
            } catch (e) {
                this.connectingRtapiModalRef?.close();
                this._reportConnectionFailure(e);
                this._delayedRTAPISetupTimeout = window.setTimeout(
                    () => this.setupRealTimeMessaging(),
                    RTAPI_RECONNECT_INTERVAL_SECONDS * 1000
                );
            }
        }

        completeRealTimeMessagingSetup() {
            this._realTimeApiConnectionEstablished();
            this._subscribeToRealTimeEvents();
        }

        _realTimeApiConnectionEstablished() {
            setTimeout(
                () => this.connectingRtapiModalRef?.close(),
                1000
            );
            if (this._lastRTAPIConnectError) {
                this._notifier.clear(this._rtapiConnectToast);
                this._rtapiConnectToast = undefined;
                this._lastRTAPIConnectError = undefined;
                if (this.channelIsEnabled) {
                    this.enableHeartbeat();
                }
                this._notifier.info("Connection to Real-Time events established!");
            }
        }

        _reportConnectionFailure(err) {
            this._orderUpOrderService.disconnectRTAPI();
            console.warn(`RTAPI connection failed, will retry in ${RTAPI_RECONNECT_INTERVAL_SECONDS}s`, err);
            const
                now = new Date(),
                timeString = `${window.Dashboard.helpers.commonHelper.zeroPad(now.getHours())}:${window.Dashboard.helpers.commonHelper.zeroPad(now.getMinutes())}`,
                message = `[${timeString}] Orders cannot be processed: unable to connect to Real-Time messaging!`;

            if (message !== this._lastRTAPIConnectError) {
                this._notifier.clear(this._rtapiConnectToast);
            }
            this._lastRTAPIConnectError = message;
            this.isOnline = false; // subsequent heartbeats should bring this back
            this.disableHeartbeat();
            this._rtapiConnectToast = this._notifier.error(
                message,
                0, // keep this message up
                false // no close button!
            ) || this._rtapiConnectToast;
        }

        _subscribeToRealTimeEvents() {
            this._subscribeToStoreEvents();
            this._subscribeToOrderEvents();
        }

        _subscribeToOrderEvents() {
            const {
                newOrder,
                acceptedOrder,
                declinedOrder,
                capturedOrder,
                completedOrder,
                timedOutOrder
            } = this._orderUpLookup.orderUpEvents;
            this._orderUpOrderService.on(
                newOrder,
                order => this._handleNewOrder(order)
            );
            this._orderUpOrderService.on(
                acceptedOrder,
                order => this._handleAcceptedOrder(order)
            );
            this._orderUpOrderService.on(
                declinedOrder,
                order => this._handleDeclinedOrder(order)
            );
            this._orderUpOrderService.on(
                capturedOrder,
                order => this._handleCapturedOrder(order)
            );
            this._orderUpOrderService.on(
                completedOrder,
                order => this._handleCompletedOrder(order)
            );
            this._orderUpOrderService.on(
                timedOutOrder,
                order => this._handleTimedOutOrder(order)
            );
        }

        _handleNewOrder(order) {
            if (!!this.acceptedOrders.find(o => o.OrderGuid === order.OrderGuid)) {
                return;
            }
            const newIdx = window.Dashboard.helpers.commonHelper.findIndex(
                this.newOrders,
                o => o.OrderGuid === order.OrderGuid
            );
            if (newIdx > -1) {
                this.newOrders.splice(newIdx, 1, order);
            } else {
                this.newOrders.push(order);
                this.playAudioNotification();
            }
            this.$scope.$applyAsync();
        }

        _handleAcceptedOrder(order) {
            this._updateOrderListsWithAccepted(order);
            this.$scope.$applyAsync();
        }

        _handleCapturedOrder(order) {
            this._updateOrderListsWithCaptured(order);
            this.$scope.$applyAsync();
        }

        _handleCompletedOrder(order) {
            this._updateOrderListsWithCompleted(order);
            this.$scope.$applyAsync();
        }

        _updateOrderListsWithAccepted(order) {
            const matcher = (o => o.OrderGuid === order.OrderGuid);
            const acceptedIdx = window.Dashboard.helpers.commonHelper.findIndex(this.acceptedOrders, matcher);
            const newIdx = window.Dashboard.helpers.commonHelper.findIndex(this.newOrders, matcher);
            if (newIdx > -1) {
                this.newOrders.splice(newIdx, 1);
                if (this.newOrders.length === 0) {
                    this.stopAudioNotification();
                }
            }
            if (acceptedIdx === -1) {
                this.acceptedOrders.push(order);
            }
        }

        compareByOrderCompletionTime() {
            return (a, b) => new Date(b.CompletionTime) - new Date(a.CompletionTime);
        }

        _updateOrderListsWithCaptured(order) {
            const matcher = (o => o.OrderGuid === order.OrderGuid);
            const capturedIdx = window.Dashboard.helpers.commonHelper.findIndex(this.capturedOrders, matcher);
            const acceptedIdx = window.Dashboard.helpers.commonHelper.findIndex(this.acceptedOrders, matcher);
            if (acceptedIdx > -1) {
                this.acceptedOrders.splice(acceptedIdx, 1);
            }
            if (capturedIdx > -1) {
                this.capturedOrders.splice(capturedIdx, 1, order);
            } else {
                this.capturedOrders.push(order);
            }
        }

        _updateOrderListsWithCompleted(order) {
            const matcher = (o => o.OrderGuid === order.OrderGuid);
            const completedIdx = window.Dashboard.helpers.commonHelper.findIndex(this.completedOrders, matcher);
            const capturedIdx = window.Dashboard.helpers.commonHelper.findIndex(this.capturedOrders, matcher);
            if (capturedIdx > -1) {
                this.capturedOrders.splice(capturedIdx, 1);
            }
            if (completedIdx > -1) {
                this.completedOrders.splice(completedIdx, 1, order);
            } else {
                this.addToCompletedAndSort(order);
            }
        }

        addToCompletedAndSort(order) {
            this.setCompletionTimes(order);
            this.completedOrders.push(order);
            this.completedOrders.sort(this.compareByOrderCompletionTime());
        }

        setCompletionTimes(order) {
            const currentISODate = new Date().toISOString();
            order.CompletionTime = order.CompletionTime ?? currentISODate;
            order.OrderUpCompletionDate = order.OrderUpCompletionDate ?? currentISODate;
        }

        _handleDeclinedOrder(order) {
            this._ejectOrderByGuid(order);
        }

        _handleTimedOutOrder(order) {
            this._ejectOrderByGuid(order);
        }

        _ejectOrderByGuid(order) {
            const
                matcher = (o => o.OrderGuid === order.OrderGuid),
                newIdx = window.Dashboard.helpers.commonHelper.findIndex(this.newOrders, matcher),
                acceptedIdx = window.Dashboard.helpers.commonHelper.findIndex(this.acceptedOrders, matcher);
            if (newIdx === -1 && acceptedIdx === -1) {
                return;
            }
            if (newIdx > -1) {
                this.newOrders.splice(newIdx, 1);
                if (this.newOrders.length === 0) {
                    this.stopAudioNotification();
                }
            }
            if (acceptedIdx > -1) {
                this.acceptedOrders.splice(acceptedIdx, 1);
            }
            if (this.selectedOrder?.OrderGuid === order.OrderGuid) {
                this.initialiseSelectedOrder();
            }
            this.$scope.$applyAsync();
        }

        _subscribeToStoreEvents() {
            const { storeOffline, storeOnline, channelDisabled, channelEnabled } = this._orderUpLookup.orderUpEvents;
            this._orderUpOrderService.on(storeOffline, message => this._setStoreOnline(false, message));
            this._orderUpOrderService.on(storeOnline, () => this._setStoreOnline(true));
            this._orderUpOrderService.on(channelEnabled, () => this._setStoreChannelState(true));
            this._orderUpOrderService.on(channelDisabled, () => this._setStoreChannelState(false));
        }

        _setStoreChannelState(channelIsEnabled) {
            if (channelIsEnabled === this.channelIsEnabled) {
                return;
            }
            this.channelIsEnabled = channelIsEnabled;
            this.$scope.$applyAsync();
            this.showStatusChangedModal();
        }

        _setStoreOnline(isOnline, message) {
            if (isOnline === this.isOnline) {
                return;
            }
            if (!isOnline) {
                this.showDisconnectedModal();
                this._rtapiConnectToast = this._notifier.info(
                    message,
                    0,
                    false
                );
            } else {
                this.disconnectedModalRef?.close();
                if (this._rtapiConnectToast) {
                    this._notifier.clear(this._rtapiConnectToast);
                }
            }
            this.isOnline = isOnline;
            this.$scope.$applyAsync();
        }

        setOrdersStateFrom(data) {
            this.newOrders = data.NewOrders || [];
            if (this.newOrders.length) {
                this.playAudioNotification();
            }
            this.acceptedOrders = data.AcceptedOrders || [];
            this.capturedOrders = (data.CapturedOrders || []);
            this.completedOrders = (data.CompletedOrders || []).sort(this.compareByOrderCompletionTime());
        }

        async setupCurrentState() {
            const result = await this._orderUpOrderService.poll(this.userContext.StoreId);
            if (!result.data) {
                this._notifier.error("Something went wrong, please try again.");
                return;
            }
            await this.setStoreStateFrom(result.data.StoreStatus);
            this.setOrdersStateFrom(result.data);
        }

        async setup() {
            const previousStatus = this.isOnline;
            try {
                this.showConnectingRtapiModal();
                await this.setupCurrentState();

                // When in mobile view we do not want to auto select the first order
                if (!this.isMobileView()) {
                    this.initialiseSelectedOrder();
                }

                if (!this.firstLoad
                    && previousStatus !== this.isOnline) {
                    this.showStatusChangedModal();
                }

                this.firstLoad = false;
                this.enableHeartbeat();
                this.monitorCompletedOrders();
            } catch (e) {
                console.error(e);
                this._notifier.error("Something went wrong setting up, please try again.");
            }
        }

        monitorCompletedOrders() {
            if (this.completedOrdersMonitor) {
                return;
            }
            this.completedOrdersMonitor = window.setInterval(
                this.trimExpiredCompletedOrders.bind(this),
                COMPLETED_ORDERS_TRIM_INTERVAL_SECONDS * 1000
            );
        }

        trimExpiredCompletedOrders() {
            if (!this.completedOrders?.length) {
                return;
            }
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            this.completedOrders = this.completedOrders
                .filter(
                    item => {
                        const d = new Date(item.CompletionTime);
                        d.setHours(0, 0, 0, 0);
                        return d.getTime() >= today.getTime();
                    }
                );
            this.$scope.$applyAsync();
        }

        showStatusChangedModal() {
            this.showStatusChangedModalRef = this._modalService.open({
                animation: true,
                templateUrl: "components/store/order-up/order-up-status-changed-modal.df1999a2.html",
                controller: "OrderUpStatusChangedModalController",
                size: "sm",
                backdrop: "static",
                windowClass: "centered-modal",
                resolve: {
                    status: () => {
                        return this.channelIsEnabled;
                    }
                }
            });
        }

        hasOrders() {
            return !!this.newOrders.length ||
                !!this.acceptedOrders.length ||
                !!this.capturedOrders.length ||
                !!this.completedOrders.length;
        }

        stopAudioNotification() {
            if (!this.notification) {
                return;
            }
            this.notification.stop();
            this.notificationAudioIsPlaying = false;
        }

        playAudioNotification() {
            if (!this.notification || this.notificationAudioIsPlaying) {
                return;
            }
            try {
                this.notification.mute(false);
                this.notification.play();
                this.notificationAudioIsPlaying = true;
            } catch (e) {
                console.error("Could not play audio notification", e);
                this._notifier.warn("Could not play audio notification for order.");
            }
        }

        initialiseSelectedOrder() {
            if (this.newOrders.length > 0) {
                this.selectOrder(this.newOrders[0]);
            } else if (this.acceptedOrders.length > 0) {
                this.selectOrder(this.acceptedOrders[0]);
            } else if (this.capturedOrders.length > 0) {
                this.selectOrder(this.capturedOrders[0]);
            } else if (this.completedOrders.length > 0) {
                this.selectOrder(this.completedOrders[0]);
            } else {
                this.selectedOrder = null;
            }
        }

        selectNextOrder(previousIndex) {
            if (!this.hasOrders()) {
                this.selectedOrder = null;
                return;
            }
            if (this.newOrders.length === 0) {
                this.initialiseSelectedOrder();
                return;
            }
            if (this.newOrders.length === previousIndex) {
                this.selectOrder(this.newOrders[previousIndex - 1]);
                return;
            }
            this.selectOrder(this.newOrders[previousIndex]);
        }

        acknowledgeOrder(order) {
            this.selectOrder(order);
            this.stopAudioNotification();
        }

        selectOrder(order) {
            this.selectedOrder = order;
        }

        selectedNewOrderIndex() {
            return (this.newOrders || []).findIndex(
                o => o.OrderGuid === this.selectedOrder?.OrderGuid
            );
        }

        isNewOrder() {
            return this.selectedNewOrderIndex() > -1;
        }

        selectedAcceptedOrderIndex() {
            return (this.acceptedOrders || []).findIndex(
                o => o.OrderGuid === this.selectedOrder?.OrderGuid
            );
        }

        isAcceptedOrder() {
            return this.selectedAcceptedOrderIndex() > -1;
        }

        selectedCapturedOrderIndex() {
            return (this.capturedOrders || []).findIndex(
                o => o.OrderGuid === this.selectedOrder?.OrderGuid
            );
        }

        isCapturedOrder() {
            return this.selectedCapturedOrderIndex() > -1;
        }

        selectedCompletedOrderIndex() {
            return (this.completedOrders || []).findIndex(
                o => o.OrderGuid === this.selectedOrder?.OrderGuid
            );
        }

        isCompletedOrder() {
            return this.selectedCompletedOrderIndex() > -1;
        }

        statusButtonText() {
            return this.canAcceptOrders ? "Disable" : "Enable";
        }

        resetSelectedOrder() {
            this.selectedOrder = null;
        }

        setDelayTime(time) {
            this.delayTimeInMinutes = time;
        }

        hasDelayOptions() {
            return this.filterDelayTimeOptionsByMax(this.maxDelayTimeInMinutes).length > 1;
        }

        canDelay() {
            return this.selectedOrder.StateId === window.Dashboard.Models.Lookups.OrderStates.PendingOrderUpResponse &&
                this.hasDelayOptions();
        }

        acceptWithDelay() {
            this.stopAudioNotification();
            this.acceptWithDelayModalRef = this._modalService.open({
                animation: true,
                templateUrl: "components/store/order-up/order-up-delay-order-modal.653559f3.html",
                controller: "OrderUpDelayOrderModalController",
                size: "sm",
                backdrop: "static",
                windowClass: "centered-modal",
                resolve: {
                    isCollect: () => this.selectedOrder.IsCollect,
                    timeOptions: () => this.filterDelayTimeOptionsByMax(this.maxDelayTimeInMinutes),
                    setDelayTime: () => async (time) => {
                        this.delayTimeInMinutes = time;
                        await this.accept();
                    },
                    delayTime: () => this.delayTimeInMinutes
                }
            });
        }

        async accept() {
            this.isAcceptingOrder = true;
            this.stopAudioNotification();
            try {
                await this._orderUpOrderService
                    .acceptOrder(this.selectedOrder.OrderGuid, this.delayTimeInMinutes);
                this._updateOrderListsWithAccepted(this.selectedOrder);
                this.$scope.$applyAsync();
            } catch (e) {
                this._notifier.error("Order could not be accepted. Please try again.");
            }
            this.isAcceptingOrder = false;
        }

        decline() {
            this.stopAudioNotification();
            this.declineModalRef = this._modalService.open({
                animation: true,
                templateUrl: "components/store/order-up/order-up-reject-modal.91dbf91f.html",
                controller: "OrderUpRejectModalController",
                size: "sm",
                backdrop: "static",
                windowClass: "centered-modal",
                resolve: {
                    orderGuid: () => {
                        return this.selectedOrder.OrderGuid;
                    }
                }
            });
        }

        async remove() {
            this.isRemovingOrder = true;
            this.stopAudioNotification();
            try {
                await this._orderUpOrderService.removeOrder(this.selectedOrder.OrderGuid);
                const index = this.selectedNewOrderIndex();
                this.acceptedOrders = this.acceptedOrders
                    .filter(item => item.OrderGuid !== this.selectedOrder.OrderGuid);
                this.selectNextOrder(index);
                this.$scope.$applyAsync();
            } catch (e) {
                this._notifier.error("Order could not be removed. Please try again.");
            }
            this.isRemovingOrder = false;
        }

        async capture() {
            this.isCapturingOrder = true;
            this.stopAudioNotification();
            try {
                await this._orderUpOrderService.captureOrder(this.selectedOrder.OrderGuid);
                this._updateOrderListsWithCaptured(this.selectedOrder);
                this.$scope.$applyAsync();
            } catch (e) {
                this._notifier.error("Order could not be set as completed. Please try again.");
            }
            this.isCapturingOrder = false;
        }

        async complete() {
            this.completeModalRef = this._modalService.open({
                animation: true,
                templateUrl: "components/store/order-up/order-up-confirm-order-status-update-modal.4150cc32.html",
                controller: "OrderUpConfirmOrderStatusUpdateModalController",
                size: "md",
                backdrop: "static",
                windowClass: "centered-modal",
                resolve: {
                    orderGuid: () => {
                        return this.selectedOrder.OrderGuid;
                    },
                    isCollect: () => {
                        return this.selectedOrder.IsCollect;
                    },
                    notificationsEnabled: () => {
                        return this.orderCompleteNotificationsEnabled;
                    },
                    deliveryIsTrackable: () => {
                        return this.selectedOrder.DeliveryIsTrackable;
                    },
                    callback: () => {
                        return () => {
                            const index = this.selectedNewOrderIndex();
                            this._updateOrderListsWithCompleted(this.selectedOrder);
                            this.selectNextOrder(index);
                            this.$scope.$applyAsync();
                            this._notifier.success(`Order successfully marked as ${ this.selectedOrder.IsCollect ? "ready for collection" : "out for delivery" }.`);
                        }
                    }
                }
            });
        }

        isMobileView() {
            return $("body.body-small").length > 0;
        }

        shouldAddShowOrderClass() {
            return this.isMobileView() && this.hasOrders() && !!this.selectedOrder;
        }

        timeOption(value, label) {
            return { value: value, label: label || value.toString() }
        }

        filterDelayTimeOptionsByMax(maxTime) {
            const increment = 5;
            const timeOptions = [
                this.timeOption(0, "None"),
                ...Array.from(
                    { length: Math.floor(maxTime / increment) },
                    (_, i) => this.timeOption((i + 1) * increment)
                ),
                ...(maxTime % increment !== 0 ? [this.timeOption(maxTime)] : [])
            ];
            return timeOptions.filter(option => option.value <= maxTime);
        }
    }

    angular.module("dashboard")
        .component("orderUpMain", {
            templateUrl: "components/store/order-up/order-up-main.1e39f712.html",
            controller: [
                "$scope",
                "$uibModal",
                "OrderUpOrdersService",
                "PermissionService",
                "$state",
                "OrderUpLookup",
                "notify",
                LiveOrdersComponent
            ]
        });
})();
